import { z } from "zod";

import { UserEntity } from "~/entities/user/@x/auth";

const zIn = UserEntity.zSchema
  .pick({
    email: true,
    password: true,
  })
  .extend({
    rememberMe: z.boolean(),
  });
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
